enum ProductTier {
  'SPARK_ADVANCED' = 'SPARK_ADVANCED',
  'SPARK_20' = 'SPARK_20',
  'SPARK_10' = 'SPARK_10',
  'IDB' = 'IDB',
}

export { ProductTier }
